import styles from "./Service.module.scss";
import commonStyles from "../Common.module.scss";
import iconStyles from "../../components/Icon.module.scss";
import buttonStyles from "../../components/Button.module.scss";
import { Helmet } from "react-helmet-async";

const Service = () => {
  return (
    <>
      <Helmet>
        <title>
          Service | International Reformed Evangelical Church in Stockholm
        </title>
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta
          name="description"
          content="We are Bible-believing, Reformed church that aims to share the Gospel to the people in Stockholm. Join us on Sundays for worship in English. Welcome to International Reformed Evangelical Church Stockholm (PRII Stockholm)."
        />
        <meta
          name="keywords"
          content="sunday service stockholm, church service, worship stockholm, Sunday school stockholm, christian worship, reformed evangelical service, IREC service, PRII service, morning worship, bible teaching stockholm, pastoral care"
        />
        <meta
          itemProp="description"
          content="We are Bible-believing, Reformed church that aims to share the Gospel to the people in Stockholm. Join us on Sundays for worship in English. Welcome to International Reformed Evangelical Church Stockholm (PRII Stockholm)."
        />
        <meta
          name="og:title"
          property="og:title"
          content="Service | International Reformed Evangelical Church in Stockholm"
        />
        <meta
          name="og:description"
          property="og:description"
          content="We are Bible-believing, Reformed church that aims to share the Gospel to the people in Stockholm. Join us on Sundays for worship in English. Welcome to International Reformed Evangelical Church Stockholm (PRII Stockholm)."
        />
        <meta name="og:type" property="og:type" content="website" />
        <meta
          name="og:url"
          property="og:url"
          content="https://irec-stockholm.org/service"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Service | International Reformed Evangelical Church in Stockholm"
        />
        <meta
          name="twitter:description"
          content="We are Bible-believing, Reformed church that aims to share the Gospel to the people in Stockholm. Join us on Sundays for worship in English."
        />
        <meta
          name="og:image"
          property="og:image"
          content="https://irec-stockholm.org/map.png"
        />
        <meta
          name="og:image:alt"
          property="og:image:alt"
          content="Map showing IREC Stockholm location and service details - Sunday worship at 10:00 AM"
        />
        <meta name="og:image:width" property="og:image:width" content="1200" />
        <meta name="og:image:height" property="og:image:height" content="630" />
        <meta
          name="twitter:image"
          content="https://irec-stockholm.org/map.png"
        />
        <link rel="canonical" href="https://irec-stockholm.org/service" />
      </Helmet>
      <div className={`${commonStyles.page} ${commonStyles.red}`}>
        <section id="service-info" className={styles["service-info"]}>
          <div className={styles.title}>
            <h1>Come to worship</h1>
            <h3>and learn the Word of God together</h3>
          </div>
          <div className={styles.wrapper}>
            <div className={styles.desc}>
              <div id="start-time" className={styles["start-time"]}>
                <h3>Service starts at</h3>
                <h1>10:00 AM</h1>
                <h6 id="sunday-school" className={styles["sunday-school"]}>
                  Children will join first half of the service and continued
                  with Sunday school.
                </h6>
              </div>
              {/* <div id="start-time"className={styles["start-time"]}>
                <h3>Service starts at</h3>
                <h1 style={{
                  textDecoration: "line-through",
                }}>10:00 AM</h1>
                <h6 style={{
                  color: "red",
                }}>
                  Important notice!<br />Only for this Sunday, Sep 6,<br />service will start at 9:45 AM. 
                </h6>
                <h6 id="sunday-school" className={styles["sunday-school"]}>
                  Children will join first half of the service and continued with Sunday school.
                </h6>
              </div> */}
              <div className={styles.info}>
                <h6>
                  After the service, we will be glad if you could join our table
                  fellowship, getting to know one another.
                </h6>
              </div>
            </div>
            <div className={styles.map}>
              <div
                id="stockholm-map"
                className={styles["stockholm-map"]}
                style={{
                  backgroundImage: "url(map.png)",
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                }}
              ></div>
              <div className={styles.info}>
                <div
                  id="stockholm-address"
                  className={styles["stockholm-address"]}
                >
                  <h6>
                    Storgatan 49
                    <br />
                    171 52 Solna
                  </h6>
                </div>

                <a
                  href="https://www.google.com/maps/dir//Storgatan+49,+171+52+Solna/@59.3494611,17.9017767,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x465f9d2a06dc01b7:0x29e19aeeaf2e1d4!2m2!1d17.9841764!2d59.3494871?entry=ttu&g_ep=EgoyMDI1MDgxOS4wIKXMDSoASAFQAw%3D%3D"
                  className={`${buttonStyles.button}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Get directions
                  <i
                    className={`${iconStyles.icon} ${styles.icon} ${iconStyles.launch}`}
                  ></i>
                </a>
              </div>
            </div>
          </div>
          <div className={styles.quote}>
            “Oh come, let us worship and bow down; let us kneel before the Lord,
            our Maker! For he is our God, and we are the people of his pasture,
            and the sheep of his hand.”
            <p>Psalm 95:6-7</p>
          </div>
        </section>
      </div>
    </>
  );
};

export default Service;
